require('./modal-directive.html');
require('./loading-directive.html');

exports.inject = function(module) {
  module.directive('loadingPage', exports.directiveLoading);
  module.directive('bootstrapTooltip', exports.bootstrapToolTip);
  module.factory('Modal', exports.factoryModal);
  module.directive('bootstrapModal', ['Modal', exports.directiveModal]);
  module.filter('startFrom', exports.filterStartFrom);
};

exports.directiveLoading = function() {
  return {
    restrict: 'E',
    templateUrl: 'loading-directive.html',
    link:function() {

    }
  };
};

exports.bootstrapToolTip = function() {
  return {
    restrict: 'AE',
    scope: {
      tooltip: '='
    },
    link:function(scope, element) {
      element.tooltip({
        title: scope.tooltip
      });
    }
  };
};

exports.filterStartFrom = function() {
  return function(input, start) {
    start = +start;
    return input.slice(start);
  };
};

exports.factoryModal = function() {
  return {
    data: null,
    show: function(data) {
      this.data = data;
    }
  };
};

exports.directiveModal = function (Modal) {
  return {
    restrict: 'E',
    templateUrl: 'modal-directive.html',
    link:function(scope, element) {
      scope.PAGINATION = {
        curPage: 1,
        allPages: 0,
        perPage: 10
      };

      scope.$watch(function() {
        return Modal.data;
      }, function(newValue, oldValue) {
        if(newValue != oldValue) {
          scope.MODEL = Modal.data;
          scope.PAGINATION.allPages = Math.ceil(scope.MODEL.conference.conference_calls.length / scope.PAGINATION.perPage);
          jQuery(element.find('#common-modal')).modal('show');
        }
      });

      scope.loadPage = function(page) {
        if(page !== undefined && (scope.PAGINATION.curPage = page)) {
          return;
        }

        page = scope.PAGINATION.curPage;
      };

      scope.loadPage();

      scope.nextPage = function() {
        if (scope.PAGINATION.curPage < scope.PAGINATION.allPages) {
          scope.PAGINATION.curPage++;
          scope.loadPage();
        }
      };

      scope.previousPage = function() {
        if (scope.PAGINATION.curPage > 1) {
          scope.PAGINATION.curPage--;
          scope.loadPage();
        }
      };

      scope.range = function (start, end) {
        var ret = [];
        if (!end) {
          end = start;
          start = 1;
        }
        for (var i = start; i <= end; i++) {
          ret.push(i);
        }
        return ret;
      };
    }
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/page-directives.js
 ** module id = 229
 ** module chunks = 0
 **/